export default __webpack_public_path__ + "static/sumit-das-resume-236c65ab6660632850ea78c36f42ba33.pdf";